import type { CritterSettings } from '../../shared/game/world-types.js';

/**
 * Rabbits browse the meadows and woodland edges, deer keep to the pines, sheep to the heath, crabs scuttle on the strand and
 * butterflies work the flowery meadows by day; crows work the ground near the party, gulls loaf on the strand, and now
 * and then a flock crosses the sky overhead. By night the daylight kinds are gone and the rest thin out. The haunts are the coast's birds on the wing: gulls beating up and down the surf
 * and riding the updraft around the lighthouse lantern, crows wheeling over the Saint's Rest graves and the Saltgrass fields.
 */
export const emberCoastCritters: CritterSettings = {
  rabbits: 6, crows: 3, gulls: 8, deer: 3, sheep: 6, crabs: 6, butterflies: 10, flyoverSeconds: [22, 70],
  haunts: [
    { kind: 'gull', count: 14, height: 12, rate: .025, beat: { z: 105, reach: 140, offshore: 26, swing: 16 } },
    { kind: 'gull', count: 9, height: 30, rate: .17, wheel: { x: -252, z: 194, radius: 17, spread: 2, squash: .85 } },
    { kind: 'gull', count: 7, height: 12, rate: .03, beat: { z: 300, reach: 110, offshore: 10, swing: 40 } },
    { kind: 'crow', count: 8, height: 14, rate: .23, wheel: { x: -116, z: -336, radius: 20, spread: 2.5, squash: .8 } },
    { kind: 'crow', count: 6, height: 10, rate: .13, wheel: { x: 170, z: 340, radius: 30, spread: 4, squash: .75 } },
  ],
};
